import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { getLocalStorage, StoreKey, setLocalStorage } from '@/src/utils/storageHelper';
export const GDPRPopup = () => {
  const $ = _c(7);
  const [isMounted, setIsMounted] = useState(false);
  const [cookieConsent, setCookieConsent] = useState("pending");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setLocalStorage(StoreKey.COOKIE_CONSENT, value);
      setCookieConsent(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleCookie = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMounted(true);
      const value_0 = getLocalStorage(StoreKey.COOKIE_CONSENT);
      setCookieConsent(value_0 === "accepted" ? "accepted" : "pending");
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!isMounted) {
    return null;
  }
  const t3 = `fixed duration-500 ${cookieConsent === "pending" ? "bottom-0" : "-bottom-96"} left-0 z-50 w-full bg-[#464E5F] py-1 text-white`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="w-full text-center lg:text-start">{"We utilize cookies to provide you with the best possible experience. Your continued use of this site indicates your satisfaction."}</p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="container mx-auto flex flex-col items-center gap-6 p-6 text-sm leading-[150%] lg:flex-row lg:justify-between lg:px-14 lg:py-4">{t4}<div className="flex items-center gap-4 whitespace-nowrap font-medium lg:gap-6"><Link href="/privacy-policy"><span className="cursor-pointer select-none leading-8 underline">Privacy Policy</span></Link><button onClick={() => handleCookie("accepted")} className="rounded-lg bg-white px-5 py-3 font-semibold text-[#464E5F] duration-100 hover:bg-white/90 lg:px-4 lg:py-2">Accept Cookies</button></div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3) {
    t6 = <div className={t3}>{t5}</div>;
    $[5] = t3;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};